var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ProtectedRoute } from '@src/app/helper';
import { Route, Routes, Outlet } from 'react-router-dom';
import ChangePasswordIndex from './ChangePassword/ChangePassword';
var ChangePasswordPage = function () {
    return (_jsx(Routes, { children: _jsx(Route, __assign({ element: _jsx(Outlet, {}) }, { children: _jsx(Route, { path: '', element: _jsx(ProtectedRoute, { permission: 'general.view', children: _jsx(ChangePasswordIndex, {}) }) }) })) }));
};
export default ChangePasswordPage;
